import type { Run } from './types'

function runTime(run: Run): number | null {
  const iso = run.started_at ?? run.created_at
  if (iso === null) return null
  const ms = Date.parse(iso)
  return Number.isNaN(ms) ? null : ms
}

/** Running first, then newest `started_at`, ties by id descending. */
export function sortRuns(runs: Run[]): Run[] {
  return [...runs].sort((a, b) => {
    const ra = a.status === 'running' ? 0 : 1
    const rb = b.status === 'running' ? 0 : 1
    if (ra !== rb) return ra - rb
    const ta = runTime(a)
    const tb = runTime(b)
    // A run with no timestamp at all sorts after every run that has one.
    if (ta !== tb) return ta === null ? 1 : tb === null ? -1 : tb - ta
    return a.id < b.id ? 1 : a.id > b.id ? -1 : 0
  })
}

export function runDurationMs(run: Run, now: number): number | null {
  if (run.started_at === null) return null
  const end = run.finished_at !== null ? Date.parse(run.finished_at) : run.status === 'running' ? now : null
  return end === null ? null : end - Date.parse(run.started_at)
}

